module.exports = __webpack_public_path__ + "img/r7.3d27ac3c.jpg";